import React from 'react'
import Images from '../ImagesComponent/Images.js'
import "../css/HomeSlider.css";

class ThumbnailMitraBanner extends React.Component {
    redirect = (args) => {
        window.location.href = args;
    };
    render() {
        const { data } = this.props
        return (
            // <div className="col-md-12">
            //     <div className="row">
            //         <div className="item">
            //             <ul id="content-slider" className="content-slider">
            //                 {data && data.map((item, index) => {
            //                     return (
            //                         <a key={index} href={'/mitra/content/'+(item.the_id)} style={{ cursor: "pointer" }}>
            //                             <li className="pt4 pb4">
            //                                 <Images alt="" src={item.image} className="mainimage" />
            //                             </li>
            //                         </a>
            //                     )
            //                 })}
            //             </ul>
            //         </div>
            //     </div>
            // </div>
            <div className="container-maincarousel" style={{ paddingTop: "50px" }}>
                <div
                    id="fammi-maincarousel"
                    className="iqbal-ganti home-slider"
                    style={{ paddingBottom: "0px", background: "none" }}>
                    <div id="myCarousel" className="carousel slide" data-ride="carousel">
                        <div className="">
                            <div className="carousel-inner">
                                {data && data.map((item, index) => {
                                    return (
                                        <div key={index} className={index === 0 ? "item active" : "item"}
                                            onClick={() => this.redirect('/mitra/content/' + (item.the_id))} >
                                            <img className="item-carousel" src={item.image} />
                                            <Images className="mobile-pict" src={item.image} />
                                        </div>
                                    )
                                })}
                            </div>
                            <div
                                className="iqbal-tambah container"
                                style={{ position: "relative" }}>
                                <ol
                                    className="carousel-indicators iqbal-ganti"
                                    style={{ bottom: "32px", left: "95px", zIndex: "1000" }}>
                                    {data && data.map(index => {
                                        return (
                                            <li
                                                data-target="#myCarousel"
                                                data-slide-to={index}
                                                className="active"
                                                style={{ marginRight: "12px" }}
                                            ></li>
                                        )
                                    })}
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ThumbnailMitraBanner